import React, { useState } from 'react';
import {
  Alert,
  TableCell,
  TableRow,
} from '@mui/material';
import { HeaderLogs } from './Logs';

interface IRowProps {
  row: ILogEntry;
  headers: HeaderLogs[];
}

export interface ILogPipelineStep {
  label: string;
  status: 'success' | 'error';
  timestamp?: string; // ex: "14:32:08"
}

export interface ILogEntry {
  id: string;
  recipient: string;
  email: string;
  template: string;
  time: string;
  subject: string;
  templateName: string;
  sentAt: string;           
  status: 'success' | 'error';
  errorMessage?: string;   
  createdAt: string;       
  steps: ILogPipelineStep[];
}

const LogsListRow = (props: IRowProps) => {
  const [error, setError] = useState<string | null>(null);

  return (
    <>
      <TableRow>
        {error && (
          <Alert severity="error" onClose={() => setError(null)}>
            {error}
          </Alert>
        )}
        {props.headers.map((head) => (
          <TableCell key={head.field} sx={{ fontFamily: 'monospace', fontSize: 11, color: '#aaa', height: 45 }}>
            {head.render
              ? head.render(props.row)
              : (props.row as Record<string, any>)[head.field] ?? ''}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
};

export default LogsListRow;
